import { render, staticRenderFns } from "./StoreroomView.vue?vue&type=template&id=0ee4bab0"
import script from "./StoreroomView.vue?vue&type=script&lang=js"
export * from "./StoreroomView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports